import { Button, Dialog, DialogActions, DialogContent, Grid2, Icon, Tooltip } from '@mui/material'
import React from 'react'
import { isInstallationType } from 'utils/CampaignUtil'
import { downloadURI, exportFile } from 'utils/ExportDataUtil'
import i18n from 'simple-react-i18n'
import { getExportAction, getInstallationName } from 'utils/VisitUtils'
import { getDate } from 'utils/DateUtil'
import PropTypes from 'prop-types'
import DtoCampaignAction from '../dto/DtoCampaignAction'
import DtoVisit from '../dto/DtoVisit'
import DtoSandreCode from 'referencial/dto/DtoSandreCode'
import { arrayOf } from 'utils/StoreUtils'
import InstallationAction from 'installation/actions/InstallationAction'
import { push } from '@lagunovsky/redux-react-router'
import InstVisitActions from '../validation/InstVisitActions'
import ProgressBar from 'components/progress/ProgressBar'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { StyledFieldSet } from 'components/StyledElements'

const headers = ['risk', 'localisation', 'equipmentType', 'responsible', 'category', 'deadline', 'interventionType', 'comment', 'correctionDate', 'commentCorrection']

const PopupTitle = ({
    campaignAction = {},
    visit = {},
    sandreCodes = [],
}) => {
    const equipmentType = isInstallationType(campaignAction.installationType)

    return (
        <StyledFieldSet style={{ position: 'sticky', top: '10' }}>
            <Grid2 container sx={{ paddingLeft: 1, fontWeight: 'bold' }}>
                <Grid2 container size={6} justifyContent='space-between'>
                    <Grid2>
                        {`${i18n.visit} : ${getDate(visit.visitDate)}`}
                    </Grid2>
                    <Grid2>
                        {`${i18n.campaign} : ${campaignAction.campaignName}`}
                    </Grid2>
                    <Grid2>
                        {`${i18n.actions} : ${visit.link_actions?.filter(la => la.correctionDate || la.commentCorrection).length} / ${visit.link_actions.length} ${i18n.finalize}`}
                    </Grid2>
                </Grid2>
                <Grid2 container size={6} justifyContent='flex-end' alignItems='center'>
                    <Icon
                        tooltip={i18n.export}
                        onClick={() => exportFile({
                            data: [
                                {
                                    ...getExportAction(sandreCodes, equipmentType, visit.link_actions[0]),
                                    headers,
                                },
                                ...visit.link_actions.slice(1).map(d => getExportAction(sandreCodes, equipmentType, d)),
                            ],
                            titleFile: `${i18n.actions}_${campaignAction.installationName || campaignAction.code}`,
                        })}
                    >file_download</Icon>
                </Grid2>
            </Grid2>
        </StyledFieldSet>
    )
}

PopupTitle.propTypes = {
    campaignAction: PropTypes.instanceOf(DtoCampaignAction),
    visit: PropTypes.instanceOf(DtoVisit),
    sandreCodes: arrayOf(DtoSandreCode),
}

const FINALISED_VISIT = 2

const PopupActions = ({
    campaignAction = {},
    visit = {},
}) => {
    const dispatch = useDispatch()

    return (
        <Grid2 container width='100%' justifyContent='space-around'>
            {visit.statusVisit > FINALISED_VISIT ? (
                <Tooltip title={i18n.noAccessVisitFinalized}>
                    <Button
                        variant='contained'
                        disabled
                    >
                        {i18n.modifVisit}
                    </Button>
                </Tooltip>
            ) : (
                <Button
                    variant='contained'
                    onClick={() => dispatch(push(`/installation/campaign/${campaignAction.idCampaign}/visit/${campaignAction.idInstallation}/5`))}
                >
                    {i18n.modifVisit}
                </Button>
            )}
            <Button
                variant='contained'
                onClick={() => {
                    dispatch(InstallationAction.getEditionInstallation(campaignAction.idCampaign, campaignAction.idInstallation)).then(json => {
                        downloadURI(json.targetPath)
                    })
                }}
            >
                {i18n.exportVisit}
            </Button>
            <Button
                variant='contained'
                onClick={() => dispatch(push(`/installation/campaign/${campaignAction.idCampaign}/visit/${campaignAction.idInstallation}/operatorFeedback`))}
            >
                {i18n.operatorFeedback}
            </Button>
        </Grid2>
    )
}

PopupActions.propTypes = {
    campaignAction: PropTypes.instanceOf(DtoCampaignAction),
    visit: PropTypes.instanceOf(DtoVisit),
    setClose: PropTypes.func,
}

const CampaignActionPopup = ({
    campaignAction = {},
    dataLoaded = false,
    open = false,
    setClose = {},
}) => {
    const {
        visit,
        sandreCodes,
        installationsTypes,
    } = useSelector((store) => ({
        visit: store.InstallationReducer.visit,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        installationsTypes: store.InstallationReducer.installationsTypes,
    }), shallowEqual)

    const installationName = getInstallationName(installationsTypes, campaignAction)

    return (
        <Dialog
            open={open}
            onClose={setClose}
            maxWidth='lg'
            slotProps={{
                paper: {
                    sx: {
                        minHeight: '90vh',
                        maxHeight: '90vh',
                    },
                },
            }}
        >
            <DefaultDialogTitle
                title={installationName}
                onClose={setClose}
            />
            <DialogContent>
                <PopupTitle
                    campaignAction={campaignAction}
                    visit={visit}
                    sandreCodes={sandreCodes}
                />
                {
                    dataLoaded && <InstVisitActions visit={visit} /> || <ProgressBar indeterminate withMessage />
                }
            </DialogContent>
            <DialogActions>
                <PopupActions
                    campaignAction={campaignAction}
                    visit={visit}
                    setClose={setClose}
                />
            </DialogActions>
        </Dialog>
    )
}

CampaignActionPopup.propTypes = {
    campaignAction: PropTypes.instanceOf(DtoCampaignAction),
    dataLoaded: PropTypes.bool,
    open: PropTypes.bool,
    setClose: PropTypes.func,
}

export default CampaignActionPopup